export const getSideMenu = (state) => state.sideMenu.menu;

export const getSideMenuPending = (state) => state.sideMenu.pending;
